// @ts-nocheck
import './SocialsShare.css';
import React from 'react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, } from 'react-share';
import { IconFacebook } from '../../icons/IconFacebook/IconFacebook';
import { IconLinkedin } from '../../icons/IconLinkedin/IconLinkedin';
import { IconTwitter } from '../../icons/IconTwitter/IconTwitter';
import { cn } from '../../utils/bem';
import { SocialButton } from '../SocialButton/SocialButton';
import { Typography } from '../Typography';
export var cnSocialsShare = cn('SocialsShare');
export var SocialsShare = function (_a) {
    var url = _a.url, title = _a.title, onClick = _a.onClick;
    return (React.createElement("div", { className: cnSocialsShare() },
        title && (React.createElement("div", { className: cnSocialsShare('Title') },
            React.createElement(Typography.Text, { weight: "bold", size: "xs", transform: "uppercase", as: "span" }, title))),
        React.createElement("div", { className: cnSocialsShare('List') },
            React.createElement(FacebookShareButton, { url: url },
                React.createElement(SocialButton, { icon: IconFacebook, as: "div", onClick: function () { return onClick('facebook'); } })),
            React.createElement(TwitterShareButton, { url: url },
                React.createElement(SocialButton, { icon: IconTwitter, as: "div", onClick: function () { return onClick('twitter'); } })),
            React.createElement(LinkedinShareButton, { url: url },
                React.createElement(SocialButton, { icon: IconLinkedin, as: "div", onClick: function () { return onClick('linkedin'); } })))));
};
